import AddCircleIcon from '@material-ui/icons/AddCircle';
import React, { Component } from 'react';
import { Obstacle, Point } from '..';
import { PointFormEditor } from '../Geometry/PointFormEditor';
import produce from 'immer'
import { Accordion, Button, Card } from 'react-bootstrap';
import { RiDeleteBin2Fill, RiDeleteBin2Line, RiShapeLine } from "react-icons/ri";

export { ObstacleDetails }

function ObstacleDetails(props: {
  obstacle: Obstacle
  onChange: (obstacle: Obstacle) => void
  onDelete?: () => void
}) {

  const addPoint = (index: number) => {
    return () => {
      let point: [number, number]
      if(props.obstacle.points.length > 2) {
        let prev: [number, number], succ: [number, number]
        if(index === 0) {
          prev = props.obstacle.points[props.obstacle.points.length - 1]
        } else {
          prev = props.obstacle.points[index - 1]
        }

        if(index === props.obstacle.points.length) {
          succ = props.obstacle.points[0]
        } else {
          succ = props.obstacle.points[index]
        }
        point = [0.5 * (prev[0] + succ[0]), 0.5 * (prev[1] + succ[1])]
      } else {
        point = [0, 0]
      }
      props.onChange(produce(props.obstacle, (draft: Obstacle) => {
        draft.points.splice(index, 0, point)
      }))
    }
  }

  const deletePoint = (index: number) => {
    return () => {
      props.onChange(produce(props.obstacle, (draft: Obstacle) => {
        draft.points.splice(index, 1)
      }))
    }
  }

  const changePoint = (index: number) => {
    return (point: [number, number]) => {
      props.onChange(produce(props.obstacle, (draft: Obstacle) => {
        draft.points.splice(index, 1, point)
      }))
    }
  }

  let deleteButton
  if(props.onDelete !== undefined) {
    deleteButton = <Button
      key='delete'
      onClick={props.onDelete}
      variant="outline-remove"
    >
      <RiDeleteBin2Line /> Remove
    </Button>
  } else {
    deleteButton = <></>
  }

  let pointForms = props.obstacle.points.map((p, i) => {
    return <PointForm
      key={`${i}${p[0]} $p[1]`}
      point={p}
      onChange={changePoint(i)}
      onDelete={deletePoint(i)}
      onAdd={addPoint(i + 1)}
    />
  })

  const pointList = <ul style={{
    padding: 0
  }}>
    {pointForms}
  </ul>

  return <Card
      className='obstacleDetails'
    >
      <Card.Header>
        <RiShapeLine /> Component
      </Card.Header>
      <Card.Body>
        {deleteButton}

        {pointList}
      </Card.Body>
    </Card>
}

function PointForm(props: {
  point: Point
  onChange: (point: Point) => void
  onDelete: () => void
  onAdd: () => void
}) {
  return <li
    style={{listStyle: 'none'}}
  >
    <PointFormEditor
      point={props.point}
      onChange={props.onChange}
      onDelete={props.onDelete}
      onAdd={props.onAdd}
    />
  </li>
}
